import { makeStyles } from "@fluentui/react-components";

export const useStyles = makeStyles({
  root: {
    paddingLeft: "1rem",
    maxWidth: "960px",
    "@media(max-width: 700px)": {
      paddingLeft: 0,
    },
  },
  card: {
    paddingLeft: "2rem",
    paddingRight: "2rem",
    paddingTop: "1.5rem",
    paddingBottom: "1.5rem",
    backgroundColor: "#fff",
    borderTopLeftRadius: "16px",
    borderTopRightRadius: "16px",
    borderBottomLeftRadius: "16px",
    borderBottomRightRadius: "16px",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
    marginBottom: "1.5rem",
  },
  cardTitle: {
    marginTop: 0,
    marginBottom: "0.25rem",
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    flexWrap: "wrap",
    columnGap: "1rem",
    marginBottom: "1.25rem",
  },
  headerTitleBlock: {
    display: "flex",
    flexDirection: "column",
  },
  headerSubtitle: {
    color: "#605e5c",
    fontSize: "0.9rem",
    marginTop: "0.15rem",
  },
  statusBadge: {
    display: "inline-block",
    paddingTop: "0.2rem",
    paddingBottom: "0.2rem",
    paddingLeft: "0.75rem",
    paddingRight: "0.75rem",
    borderTopLeftRadius: "999px",
    borderTopRightRadius: "999px",
    borderBottomLeftRadius: "999px",
    borderBottomRightRadius: "999px",
    fontSize: "0.8rem",
    fontWeight: 600,
    height: "fit-content",
  },
  statusActive: {
    backgroundColor: "#dff6dd",
    color: "#107c10",
  },
  statusRequested: {
    backgroundColor: "#fff4ce",
    color: "#8a6d00",
  },
  statusDeactivated: {
    backgroundColor: "#f3f2f1",
    color: "#605e5c",
  },
  statusNone: {
    backgroundColor: "#f3f2f1",
    color: "#605e5c",
  },
  pillTabs: {
    display: "inline-flex",
    backgroundColor: "#e5f1fb",
    borderTopLeftRadius: "999px",
    borderTopRightRadius: "999px",
    borderBottomLeftRadius: "999px",
    borderBottomRightRadius: "999px",
    paddingTop: "0.25rem",
    paddingBottom: "0.25rem",
    paddingLeft: "0.25rem",
    paddingRight: "0.25rem",
    columnGap: "0.25rem",
    marginBottom: "1.5rem",
  },
  pillTab: {
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
    paddingLeft: "1.25rem",
    paddingRight: "1.25rem",
    borderTopLeftRadius: "999px",
    borderTopRightRadius: "999px",
    borderBottomLeftRadius: "999px",
    borderBottomRightRadius: "999px",
    fontWeight: 600,
    cursor: "pointer",
    borderTopStyle: "none",
    borderBottomStyle: "none",
    borderLeftStyle: "none",
    borderRightStyle: "none",
    fontSize: "0.95rem",
  },
  pillTabInactive: {
    backgroundColor: "transparent",
    color: "#0078d4",
  },
  pillTabActive: {
    backgroundColor: "#0078d4",
    color: "#fff",
  },
  pillTabDisabled: {
    backgroundColor: "transparent",
    color: "#a19f9d",
    cursor: "not-allowed !important",
  },
  fieldLabel: {
    fontWeight: 600,
    marginBottom: "0.5rem",
    display: "block",
  },
  btnRow: {
    marginTop: "1rem",
    display: "flex",
    columnGap: "10px",
  },
  divider: {
    borderTopStyle: "none",
    borderBottomStyle: "none",
    borderLeftStyle: "none",
    borderRightStyle: "none",
    borderTopWidth: "1px",
    borderTopColor: "#edebe9",
    marginTop: "1.5rem",
    marginBottom: "1.5rem",
  },
  detailsSection: {
    marginTop: "0.5rem",
  },
  detailRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "baseline",
    columnGap: "1rem",
    paddingTop: "0.75rem",
    paddingBottom: "0.75rem",
    borderBottomWidth: "1px",
    borderBottomStyle: "solid",
    borderBottomColor: "#edebe9",
  },
  detailLabel: {
    color: "#605e5c",
    fontSize: "0.9rem",
  },
  detailValue: {
    fontWeight: 600,
    textAlign: "right",
    wordBreak: "break-all",
  },
  warningBanner: {
    marginBottom: "1.5rem",
    paddingTop: "0.85rem",
    paddingBottom: "0.85rem",
    paddingLeft: "1rem",
    paddingRight: "1rem",
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
    borderBottomLeftRadius: "8px",
    borderBottomRightRadius: "8px",
    backgroundColor: "#fff4ce",
    color: "#8a6d00",
  },
  successBanner: {
    marginTop: "1.5rem",
    paddingTop: "0.85rem",
    paddingBottom: "0.85rem",
    paddingLeft: "1rem",
    paddingRight: "1rem",
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
    borderBottomLeftRadius: "8px",
    borderBottomRightRadius: "8px",
    backgroundColor: "#fde7e9",
    color: "#a80000",
    fontWeight: 600,
  },
  errorBanner: {
    marginTop: "1rem",
    marginBottom: "1rem",
    paddingTop: "0.75rem",
    paddingBottom: "0.75rem",
    paddingLeft: "1rem",
    paddingRight: "1rem",
    borderTopLeftRadius: "6px",
    borderTopRightRadius: "6px",
    borderBottomLeftRadius: "6px",
    borderBottomRightRadius: "6px",
    backgroundColor: "#fde7e9",
    color: "#a80000",
    whiteSpace: "pre-line",
  },
  stepRow: {
    display: "flex",
    columnGap: "1rem",
  },
  stepBadge: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "28px",
    height: "28px",
    minWidth: "28px",
    borderTopLeftRadius: "999px",
    borderTopRightRadius: "999px",
    borderBottomLeftRadius: "999px",
    borderBottomRightRadius: "999px",
    color: "#fff",
    fontWeight: 700,
    fontSize: "0.85rem",
  },
  stepBadgeGreen: {
    backgroundColor: "#107c10",
  },
  stepBadgeBlue: {
    backgroundColor: "#0078d4",
  },
  stepConnector: {
    width: "2px",
    flexGrow: 1,
    backgroundColor: "#edebe9",
    marginTop: "0.25rem",
    marginBottom: "0.25rem",
    marginLeft: "13px",
  },
  stepContent: {
    flexGrow: 1,
    paddingBottom: "1.5rem",
  },
  stepTitle: {
    fontWeight: 600,
    fontSize: "1rem",
    marginBottom: "0.25rem",
  },
  stepSubtitle: {
    color: "#605e5c",
    fontSize: "0.9rem",
    marginBottom: "1rem",
  },
  readonlyBox: {
    paddingTop: "0.75rem",
    paddingBottom: "0.75rem",
    paddingLeft: "1rem",
    paddingRight: "1rem",
    borderTopLeftRadius: "6px",
    borderTopRightRadius: "6px",
    borderBottomLeftRadius: "6px",
    borderBottomRightRadius: "6px",
    borderTopWidth: "1px",
    borderBottomWidth: "1px",
    borderLeftWidth: "1px",
    borderRightWidth: "1px",
    borderTopStyle: "solid",
    borderBottomStyle: "solid",
    borderLeftStyle: "solid",
    borderRightStyle: "solid",
    borderTopColor: "#edebe9",
    borderBottomColor: "#edebe9",
    borderLeftColor: "#edebe9",
    borderRightColor: "#edebe9",
    backgroundColor: "#faf9f8",
    fontFamily: "Consolas, 'Courier New', monospace",
    fontSize: "0.85rem",
    wordBreak: "break-all",
    marginBottom: "1rem",
  },
  codeBox: {
    paddingTop: "1rem",
    paddingBottom: "1rem",
    paddingLeft: "1rem",
    paddingRight: "1rem",
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
    borderBottomLeftRadius: "8px",
    borderBottomRightRadius: "8px",
    borderTopWidth: "1px",
    borderBottomWidth: "1px",
    borderLeftWidth: "1px",
    borderRightWidth: "1px",
    borderTopStyle: "solid",
    borderBottomStyle: "solid",
    borderLeftStyle: "solid",
    borderRightStyle: "solid",
    borderTopColor: "#edebe9",
    borderBottomColor: "#edebe9",
    borderLeftColor: "#edebe9",
    borderRightColor: "#edebe9",
    backgroundColor: "#faf9f8",
    fontFamily: "Consolas, 'Courier New', monospace",
    fontSize: "0.85rem",
    wordBreak: "break-all",
    maxHeight: "180px",
    overflowY: "auto",
  },
  codeBoxHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "0.5rem",
  },
  keyLabel: {
    fontWeight: 600,
    color: "#323130",
  },
  mb8: {
    marginBottom: "0.5rem",
  },
  mt16: {
    marginTop: "1rem",
  },
  generateKeyButtonEnabled: {
    backgroundColor: "#ffb900",
    borderTopColor: "#ffb900",
    borderBottomColor: "#ffb900",
    borderLeftColor: "#ffb900",
    borderRightColor: "#ffb900",
    color: "#201f1e",
  },
  generateKeyButtonDisabled: {
    backgroundColor: "#f3f2f1",
    borderTopColor: "#f3f2f1",
    borderBottomColor: "#f3f2f1",
    borderLeftColor: "#f3f2f1",
    borderRightColor: "#f3f2f1",
    color: "#a19f9d",
    cursor: "not-allowed",
  },
});
